import React from 'react';
import Svg, { Defs, LinearGradient, Path, Rect, Stop } from 'react-native-svg';

export const BeautyBadge = ()=>{
  return (
    <Svg width="46" height="18" viewBox="0 0 46 18" fill="none">
      <Rect
        width="18"
        height="18"
        rx="9"
        fill="url(#paint0_linear_18886_116739)"
      />
      <Path
        d="M5.99023 4.76721H9.67148C10.6005 4.76721 11.3215 4.99227 11.8345 5.44238C12.3544 5.89249 12.6144 6.50879 12.6144 7.29129C12.6144 7.60291 12.5208 7.9076 12.3336 8.20537C12.1464 8.49621 11.9107 8.69356 11.6265 8.79743C12.0286 8.92901 12.3579 9.17137 12.6144 9.52454C12.8778 9.87078 13.0096 10.2516 13.0096 10.6671C13.0096 11.1865 12.8882 11.6401 12.6456 12.0278C12.4099 12.4156 12.0633 12.7134 11.6057 12.9211C11.1481 13.1289 10.6074 13.2328 9.98346 13.2328H5.99023V4.76721ZM9.58829 8.19498C9.94879 8.19498 10.2261 8.11881 10.4202 7.96646C10.6213 7.80719 10.7218 7.58214 10.7218 7.29129C10.7218 6.99353 10.6213 6.76847 10.4202 6.61613C10.2261 6.45686 9.94879 6.37722 9.58829 6.37722H7.88285V8.19498H9.58829ZM9.90026 11.6227C10.2816 11.6227 10.5797 11.5396 10.7946 11.3735C11.0095 11.2073 11.1169 10.9718 11.1169 10.6671C11.1169 10.3624 11.0095 10.127 10.7946 9.9608C10.5797 9.7946 10.2816 9.71151 9.90026 9.71151H7.88285V11.6227H9.90026Z"
        fill="white"
      />
      <Path
        d="M33.6895 11.1562H31.0371V15.2168H29.5195V11.1562H26.5938V15.2168H25.0352V11.1562H22.3965V9.92578H33.6895V11.1562ZM25.2676 4.8125H30.791V3.33594H32.3223V8.66797H23.7637V3.33594H25.2676V4.8125ZM30.791 7.45117V6.00195H25.2676V7.45117H30.791ZM41.0141 5.16797H36.3246V7.36914H40.5219V8.57227H36.3246V11.1152C37.4184 11.1107 38.3731 11.0833 39.1889 11.0332C40.0046 10.9785 40.8318 10.8828 41.6703 10.7461L41.8207 11.9766C40.9001 12.1178 39.9841 12.2158 39.0727 12.2705C38.1612 12.3206 37.0902 12.3457 35.8598 12.3457H34.8207V3.92383H41.0141V5.16797ZM44.432 15.2168H42.9008V2.85742H44.432V15.2168Z"
        fill="url(#paint1_linear_18886_116739)"
      />
      <Defs>
        <LinearGradient
          id="paint0_linear_18886_116739"
          x1="6.83333"
          y1="5.78572"
          x2="21.8482"
          y2="13.8492"
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#FF717E" />
          <Stop offset="1" stopColor="#FF577A" />
        </LinearGradient>
        <LinearGradient
          id="paint1_linear_18886_116739"
          x1="25.3333"
          y1="6"
          x2="47.6719"
          y2="10.4212"
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#FF5E79" />
          <Stop offset="1" stopColor="#F85470" />
        </LinearGradient>
      </Defs>
    </Svg>
  );
}
